export const squareIconStyle = {
    height: '32px',
    width: '32px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4px'
};
